import { detect } from "detect-browser";

export const isMobile = () =>
  ["iOS", "Windows Mobile", "Android OS", "BlackBerry OS"].includes(
    detect().os
  );

export const hideClass = (className) => {
  setInterval(() => {
    if (!className) {
      return;
    }
    const classElements = document.getElementsByClassName(className);
    for (const classElement of classElements) {
      classElement.style.display = "none";
    }
  }, 1000);
};

export const updateCSSVariables = (variables) => {
  for (const key in variables) {
    document.documentElement.style.setProperty(key, variables[key]);
  }
};

export const isInternalLink = (linkUrl) => {
  try {
    const parsedLink = new URL(linkUrl);
    return window.location.hostname === parsedLink.hostname;
  } catch (e) {
    return true;
  }
};

export const openLinksByLocation = (linkUrl) => {
  if (isInternalLink(linkUrl)) {
    window.location.href = linkUrl;
    return;
  }
  window.open(linkUrl, "_blank");
};
